<template>
    <div class="newdetail_wrap">
      <div class="red_top_bg">
        <div class="back_left" @click="$router.back()"></div>
        <div class="big_tit">{{$t('orders.particular')}}</div>
      </div>
      <div class="ctn">
        <!-- Contract Header Information -->
        <div class="contract_parties">
          <p>合同编号：：{{ data.number }}</p>
          <p>甲方（租凭方）： {{ data.user_name }}</p>
          <p>乙方（管理方）： {{ data.party_b }}</p>
          <p>丙方（担保方）： {{ data.guarantee }}</p>
          <p>{{$t('orders.xieyi1')}}</p>
        </div>
  
        <!-- Contract Details Table -->
        <table class="contract_table">    
            <div class="tr_td"> 1、加盟租凭明细 </div>     
          <tr>
            <td><strong>产品名称：</strong></td>
            <td>{{ data.title }}</td>
          </tr>
          <tr>
            <td><strong>租凭人姓名：</strong></td>
            <td>{{ data.user_name }}</td>
          </tr>
          <tr>
            <td><strong>租凭人身份证：</strong></td>
            <td>{{ data.user_idcard || '（未提供）' }}</td>
          </tr>
          <tr>
            <td><strong>投入本金额(下称"甲方租凭本金")：</strong></td>
            <td>{{ data.money }}元</td>
          </tr>
          <tr>
            <td><strong>协议期(天)</strong></td>
            <td>{{ data.day }} 天</td>
          </tr>
          <tr>
            <td><strong>预期收益率：</strong></td>
            <td>{{ data.rate }}%</td>
          </tr>
          <tr>
            <td><strong>起息日：</strong></td>
            <td>{{ data.time }}</td>
          </tr>
          <tr>
            <td><strong>到期日：</strong></td>
            <td>{{ data.time2 }}</td>
          </tr>
          <tr>
            <td><strong>应收本息(元)</strong></td>
            <td>{{ data.list_souyi }}元</td>
          </tr>
          <tr>
            <td><strong>还款方式</strong></td>
            <td>{{ data.type }}</td>
          </tr>
          <tr>
            <td><strong>项目描述</strong></td>
            <td>{{ data.describe|| '' }}</td>
          </tr>
        </table>
  
        <!-- Fixed Content Section -->
        <div class="fixed_content">
            <p>{{$t('orders.xieyi2')}}</p>
            <p>{{$t('orders.xieyi3')}}</p>
            <p>{{$t('orders.xieyi4')}}</p>
            <p>{{$t('orders.xieyi5')}}</p>
            <p>{{$t('orders.xieyi6')}}</p>            
            {{$t('orders.xieyi7')}}<br>
            {{$t('orders.xieyi8')}}<br>
            {{$t('orders.xieyi9')}}<br>
            <p>{{$t('orders.xieyi10')}}</p>
            <p>{{$t('orders.xieyi11')}}</p>
        </div>
  
        <!-- Contract Content (from item_content) -->
        <!-- <div class="contract_box" v-html="data.item_content"></div> -->
  
        <!-- Signature Area -->
        <div class="signature_area">
          <div class="signature_party">
            <p>甲方：{{ data.user_name }}</p>
            <!-- <img :src="guarantorSignature" alt="甲方公章" class="signature_seal" v-if="guarantorSignature">
            <p v-else>（公章缺失）</p> -->
            <p>{{ data.c_time }}</p>
          </div>
          <div class="signature_party">
            <p>乙方： {{ data.party_b }}</p>            
            <img :src="data.borrowerSignature" alt="丙方公章" v-if="data.borrowerSignature"> 
            <!-- <p v-else>（签字缺失）</p> -->
            <p>{{ data.c_time }}</p>
          </div>
          <div class="signature_party">
            <p>丙方：{{ data.guarantee  }}</p>
            <img :src="data.guarantorSignature" alt="乙方公章" v-if="data.guarantorSignature">
            <!-- <p v-else>（公章缺失）</p> -->
            <p>{{ data.c_time }}</p>
          </div>
          
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import Fetch from "../../utils/fetch";
  import bsHeader from '../../components/bsHeader.vue';
  
  export default {
    props: ['id'], // Route parameter
    name: "article",
    components: { bsHeader },
    data() {
      return {
        data: {},
        guarantorSignature: '', 
        borrowerSignature: '',
      };
    },
    created() {
      // Call parent component method, keep as is
      this.$parent.footer('user', false);
    },
    mounted() {
      this.start();
    },
    methods: {
      start() {
        // Use this.id to get the parameter
        Fetch('/index/order_list', {
          id: this.id // Use prop directly
        }).then(res => {
          this.data = res.data;

        }).catch(err => {
            console.error("Failed to fetch order details:", err);
            // Handle error, e.g., show a message to the user
        });
      },
    },
  };
  </script>
  
  <style lang="less" scoped>
  // Inherited styles from your original code
  .red_top_bg {
    position: fixed;
    top: 0;
    background: #3775f4;
    color: #fff;
    left: 50%;
    transform: translateX(-50%);
    z-index: 10;
  }
  .tr_td{
    margin-bottom: 10px;
    font-size: 12px;
  }
  .back_left {
    background: url(../../views/images/item/back_b.png) no-repeat center center;
  }
  
  .big_tit {
    color: #FFF;
  }
  
  .newdetail_wrap {
    overflow-x: hidden;
    overflow-y: auto;
    background: #f5f5f5;
    height: 100vh; /* Ensure it takes full viewport height for scrolling */
    padding-top: 44px; /* Space for fixed header */
    box-sizing: border-box; /* Include padding in height calculation */
  }
  
  .newdetail_wrap .ctn {
    width: calc(100% - 20px); /* Adjust for padding on sides */
    background: #fff;
    padding: 10px; /* Increased padding for better readability */
    margin: 0 auto;
    box-shadow: 0 2px 8px rgba(0,0,0,0.05); /* Soft shadow for content box */
    border-radius: 8px; /* Slightly rounded corners */
  }
  
  .contract_box {
    line-height: 1.8; /* Improved line height for content */
    font-size: 12px; /* Slightly larger font for readability */
    color: #333;
    padding-top: 15px;
    border-top: 1px dashed #eee; /* Separator for content */
    margin-top: 15px;
  
    // Basic styling for images within v-html content
    /deep/ img {
      max-width: 80%;
      height: auto;
      display: block; // Remove extra space below image
      margin: 10px auto; // Center images within content
      border-radius: 4px;
    }
    /deep/ p {
      margin-bottom: 10px; // Spacing between paragraphs
    }
  }
  
  // New styles for the contract structure
  .contract_parties {
    margin-bottom: 20px;
    font-size: 12px;
    line-height: 1.6;
  
    p {
      margin-bottom: 5px;
    }
  }
  
  .contract_table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 20px;
    font-size: 12px; /* Adjust font size for table */
  
    td {
    line-height: 20px;
      padding: 10px 15px;
      border: 1px solid #efefef; /* Lighter border for a cleaner look */
    }
  
    td:first-child {
      width: 40%;
    }
  
    td:last-child {
      color: #333;
    }
  }
  
  .fixed_content {
    margin-top: 20px;
    margin-bottom: 20px;
    font-size: 12px; /* Consistent font size */
    line-height: 1.8;
    color: #444;
  
    p {
      margin-bottom: 6px;
    }
  
  
  }
  
  .signature_area {
    display: flex;
    justify-content: space-around;
    align-items: flex-start; /* Align contents to the top */
    margin-top: 30px;
    padding-top: 20px;
    margin-bottom: 80px;
    margin-top: -18px;
  }
  
  .signature_party {
    position: relative;
    text-align: center;
    flex: 1;
    padding: 0 10px;
  
    p {
      margin-bottom: 10px;
      font-size: 12px;
      color: #333;
      position: relative;
      z-index: 1;
    }
  }
  
  .signature_party img {
    position: absolute;
    left: 50%;
    top:6px;
    transform: translate(-50%, -50%);
    max-width: 90px;
    height: auto;
    border-radius: 4px;
    z-index: 2;
  }
  .signature_seal {
    max-width: 150px; /* Adjust size as needed */
    height: auto;
    border: 1px solid #eee; /* Optional border for placeholder images */
    border-radius: 4px;
    margin-top: 5px;
  }
  </style>
  